<template>
    <drop :class="{cardDropForTrans: !inInbox, cardDropForTransInbox: inInbox, cardDropDragOver: dragging}" @dragover="handleDragOver" @dragenter="handleDragOver" @dragend="dragging=false" @dragleave="dragging=false" @drop="doDrop">
        <div style="position: absolute; width: 207px; height: 176px"></div>
        <div class="pointerEventsOff">
            <div v-if="dragging" class="has-text-centered has-text-white" style="width: 30px">
                <i class="fa fa-file"></i><br>
                <i class="fa fa-arrow-down"></i>
            </div>
        </div>
    </drop>
</template>

<script>
import { Drop } from 'vue-drag-drop'

export default {
    name: 'transdropzone',
    components: {Drop},
    props: {
        //listIndex: Number,
        itemIndex: Number
    },
    data: function(){
        return {
            dragging: false,
            inInbox: this.$parent.isInbox
        }
    },
    methods: {
        handleDragOver: function(data, event){
          
            if(data.type == 'card'){
                this.dragging = true
            }
            
        },
       
        doDrop: function(data, event){
            
          

            if(data == undefined) {
                this.dragging = false
                this.$root.app.showModalOK({message: 'Drop links into "drop" zone, top left above, not directly into inbox or bundles'})
                return
            }
            

            let fromBundleId = data.bundleId
            let cardId = data.cardId
            let cardsIndex = data.cardsIndex
            let toBundleId = this.$parent.conts.id
            let before;
            let after;

            //* Get pos of neighbours from parent.conts.items
            if(this.$parent.conts.items[this.itemIndex -1] != undefined)
                before = this.$parent.conts.items[this.itemIndex -1].entryId
            else 
                before = false

            after = false;

            if((this.$root.app.cards[data.cardsIndex].id_cog != this.$root.app.userAttrs.sub) && (data.parentCollabId != this.$parent.isInbox ? 'root' : this.$parent.conts.parentCollabId)){
                this.$root.app.showModalOK({message: 'This card was not contributed to this collaboration by you. You cannot move it outside this collab bundle. Make a copy instead?', 
                                            callBack: this.$root.app.copyCardCallback, 
                                            payload: {url: '', cardsIndex: data.cardsIndex, callApi: false, caller: this, bundleId: this.$parent.conts.id, before: before, after: after, fromBundleId: data.trueFromBundleId}})
                this.dragging = false
                return
            } 

            let self = this
            function callBack(){
                self.$parent.sort()
                self.dragging = false
            }

            this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex, this.$parent.conts.aliasTgtId)
        }
    }
}
</script>
